import React from "react";
import { useTheme } from "./ThemeContext.jsx";

const SeasonalCardToggle = ({ className = "" }) => {
  const { activeCardTheme, seasonalCardsEnabled, toggleSeasonalCards } = useTheme();
  const isSeasonalCardSeason = activeCardTheme === "halloween" || activeCardTheme === "christmas";

  if (!isSeasonalCardSeason) return null;

  return (
    <div className={`seasonal-card-toggle ${className}`.trim()}>
      <label className="my-bets-page__seasonal-toggle">
        <input
          type="checkbox"
          aria-label="Seasonal card themes"
          checked={seasonalCardsEnabled}
          onChange={(event) => toggleSeasonalCards(event.target.checked)}
        />
        <span className="my-bets-page__seasonal-switch" aria-hidden="true" />
        <span className="seasonal-card-toggle__text">Seasonal theme</span>
      </label>
    </div>
  );
};

export default SeasonalCardToggle;
